module.exports = __webpack_public_path__ + "img/draw-popup-head.ce43cf0a.png";